import { AnyAction } from '@reduxjs/toolkit';
import { SetUserRoutine } from '../redux-routines';
import { IUserStoreState } from '../interfaces';

const initialState: IUserStoreState = {
  user: null,
  isFetching: false,
  error: null,
};

const userstore = (
  state: IUserStoreState = initialState,
  action: AnyAction,
): IUserStoreState => {
  switch (action.type) {
    case SetUserRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        user: action.payload,
        error: null,
      };
    case SetUserRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case SetUserRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default userstore;
